// extracted by mini-css-extract-plugin
export default {"Button":"GatewayProperties_Button__Abfhq","alerts":"GatewayProperties_alerts__CVlLL"};